export const numbers = ['zero','one','two','three','four', 'five','six','seven','eight','nine'];

export const formatDatePickerStrings = (str) => {
    return str.toLowerCase().split(' ').map(item => Number.isInteger(+item) ? numbers[+item] : item).join('_');
};